<template>
    <ul :class="bigButton ? 'big-social-share list-inline' : 'social-share list-inline'">
        <li v-if="showCopyButton" class="list-inline-item copy-link-item">
            <transition name="copy-feedback">
                <span v-if="copiedLink" class="copy-feedback" role="status">
                    {{ __('link_copied_to_clipboard') }}
                </span>
            </transition>
            <button type="button" class="copy-link-button" :title="copiedLink ? __('copied') : __('copy')"
                :aria-label="copiedLink ? __('copied') : __('copy')" @click="copySharedLink">
                <i :class="copiedLink ? 'fa-solid fa-check' : 'fa-regular fa-copy'"></i>
            </button>
        </li>
        <li class="list-inline-item" v-for="(network, index) in visibleNetworks" :key="index">
            <ShareNetwork class="test" :network="network.network" :key="network.key"
                :style="{ backgroundColor: network.color }" :url="sharedLink" :title="truckPlate
                        ? __('sharedlinks.track_vehicle_position') + ' ' + truckPlate
                        : __('sharedlinks.track_vehicle_position') + ' '
                    " @open="open">
                <i :class="network.icon"></i>
            </ShareNetwork>
        </li>
    </ul>
</template>

<script>
    import { copyToClipboard } from '@/functions/clipboard'

    export default {
        name: 'GoliaShareNetwork',
        props: {
            truckPlate: {
                type: String,
                required: false
            },
            sharedLink: {
                type: String,
                required: true
            },
            bigButton: {
                type: Boolean,
                required: false
            },
            allowedNetworks: {
                type: Array,
                default: null
            },
            showCopyButton: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                copiedLink: false,
                networks: [
                    {
                        key: 1,
                        network: 'email',
                        name: 'Email',
                        icon: 'far fah fa-lg fa-envelope',
                        color: '#333333'
                    },
                    {
                        key: 2,
                        network: 'messenger',
                        name: 'Messenger',
                        icon: 'fab fah fa-lg fa-facebook-messenger',
                        color: '#0084ff'
                    },
                    {
                        key: 3,
                        network: 'sms',
                        name: 'SMS',
                        icon: 'far fah fa-lg fa-comment-dots',
                        color: '#333333'
                    },
                    {
                        key: 4,
                        network: 'telegram',
                        name: 'Telegram',
                        icon: 'fab fah fa-lg fa-telegram-plane',
                        color: '#0088cc'
                    },
                    {
                        key: 5,
                        network: 'whatsapp',
                        name: 'Whatsapp',
                        icon: 'fab fah fa-lg fa-whatsapp',
                        color: '#25d366'
                    }
                ]
            }
        },
        computed: {
            visibleNetworks() {
                if (!this.allowedNetworks) return this.networks

                return this.networks.filter((network) =>
                    this.allowedNetworks.includes(network.network)
                )
            }
        },
        methods: {
            copySharedLink() {
                copyToClipboard(this.sharedLink)
                this.copiedLink = true

                setTimeout(() => {
                    this.copiedLink = false
                }, 2000)
            },
            /**
             * re-render del pulsante di condivisione per fa sì che si possa ri-cliccare successivamente
             *
             * @param {type} e - il social che è stato selezionato
             * @return {void}
             */
            open(e) {
                const openedNetwork = this.networks.find((n) => {
                    return n.network == e
                })
                openedNetwork.key += 1
            }
        }
    }
</script>

<style scoped>
    .social-share li a {
        font-size: 12px !important;
        margin-top: 0px;
        color: #fff;
    }

    .big-social-share li a {
        font-size: 15px !important;
        margin-top: 0px;
        color: #fff;
    }

    a {
        color: var(--dark-blue);
        display: block;
        word-break: break-all;
        padding: 4px;
        padding: 4px;
        padding-left: 6px;
        padding-right: 6px;
        border-radius: 45px;
        background: var(--main-gray);
        margin-top: 10px;
        font-size: 11px;
        position: relative;
        z-index: 1;

        &:hover {
            color: var(--dark-blue--hover);
        }
    }

    button {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 2;
    }

    input:read-only {
        position: relative;
        top: -35px;
    }

    .copy-link-item {
        position: relative;
    }

    .social-share .copy-link-button,
    .big-social-share .copy-link-button {
        position: static !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        padding: 0;
        color: #fff;
        background-color: var(--dark-blue);
        border: 0;
        border-radius: 50%;
        box-shadow: none;
        font-family: inherit;
        font-size: 12px;
        line-height: 1;
        appearance: none;
        -webkit-appearance: none;
        cursor: pointer;
    }

    .social-share .copy-link-button:hover,
    .social-share .copy-link-button:focus-visible,
    .big-social-share .copy-link-button:hover,
    .big-social-share .copy-link-button:focus-visible {
        color: #fff;
        background-color: var(--dark-blue--hover);
    }

    .social-share .copy-link-button:focus-visible,
    .big-social-share .copy-link-button:focus-visible {
        outline: 2px solid rgba(var(--dark-blue--rgb), 0.35);
        outline-offset: 2px;
    }

    .copy-feedback {
        position: absolute;
        right: 0;
        bottom: calc(100% + 5px);
        z-index: 2;
        padding: 4px 7px;
        color: #fff;
        background-color: var(--dark-blue--hover);
        border-radius: 6px;
        box-shadow: 0 3px 8px rgba(56, 73, 91, 0.18);
        font-size: 10px;
        line-height: 1.35;
        white-space: nowrap;
    }

    .copy-feedback-enter-active,
    .copy-feedback-leave-active {
        transition: opacity 0.18s ease, transform 0.18s ease;
    }

    .copy-feedback-enter,
    .copy-feedback-leave-to {
        opacity: 0;
        transform: translateY(3px);
    }
</style>
